module.exports = __webpack_public_path__ + "static/media/C21.898e15f0.png";